var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:[
        'NavTab',
        _vm.active && 'NavTab--active',
        _vm.size !== '' && ("NavTab--" + _vm.size),
        _vm.display && 'NavTab--display'
    ],attrs:{"role":"navigation","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('navigate', _vm.to)}}},[_vm._t("default",[_vm._v(_vm._s(_vm.label))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }